import { List, Skeleton, Typography } from 'antd';
import { useGetClientUsers } from 'api/client-users/use-get-client-users';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import styles from './client-user-list.module.scss';
import { ClientUserControl } from './components/client-user-control';
import type { IClientUsersListProps } from './types';

const { Text } = Typography;

export const ClientUsersList: React.FC<IClientUsersListProps> = ({ clientId }) => {
  const { data, isLoading } = useGetClientUsers(clientId);

  return (
    <Skeleton loading={isLoading}>
      <List
        itemLayout='horizontal'
        dataSource={data || []}
        renderItem={(user) => (
          <List.Item
            key={user.id}
            className={user.blockedAt ? styles.blockedUserRow : ''}
            actions={[
              <ClientUserControl key='client-user-control' clientUserId={user.id} isBlocked={!!user.blockedAt} />,
            ]}>
            <List.Item.Meta
              title={
                <>
                  <Text>{user.name} </Text>
                  <br />
                  <Text type='secondary'>{user.email}</Text>
                </>
              }
              description={
                <>
                  {user.lastOnline && (
                    <>
                      <small>Last online: {formatDateTime(user.lastOnline)}</small>
                      <br />
                    </>
                  )}
                  {user.blockedAt && <small>Blocked at: {formatDateTime(user.blockedAt)}</small>}
                </>
              }
            />
          </List.Item>
        )}></List>
    </Skeleton>
  );
};
